module.exports = __webpack_public_path__ + "static/media/seemypetcam-logo.a563e986.png";